import { ActionTree } from 'vuex';
import { IAuthState, IRootStore } from '../types';
import { api } from '@/services';
import {
  ILoginRequest, ISignUpRequest, IUserProfile, ILoginResponse, IUserLStorage,
} from '@/shared/models';
import { _axios } from '@/plugins/axios';
import { PROFILE_KEY } from '@/shared/constant';

export const actions: ActionTree<IAuthState, IRootStore> = {
  async checkUserToken({ commit }) {
    const storage = JSON.parse(localStorage.getItem(PROFILE_KEY) as string);
    if (!!storage && !!storage.tkn) {
      const user = await api.auth.getUserProfile(storage.tkn);
      const dataStorage: IUserLStorage = {
        tkn: storage.tkn,
        lastName: user.lastName,
      };
      localStorage.setItem(PROFILE_KEY, JSON.stringify(dataStorage));
      commit('LOGIN_SUCCESS');
      commit('SET_PROFILE', user, { root: true });
      return true;
    }
    return false;
  },
  async login({ commit }, payload: ILoginRequest): Promise<boolean> {
    try {
      const response: ILoginResponse = await api.auth.login(payload);
      const dataStorage: IUserLStorage = {
        tkn: response.accessToken,
        lastName: response.user.lastName,
      };
      commit('SET_HEADER', response.accessToken);
      localStorage.setItem(PROFILE_KEY, JSON.stringify(dataStorage));
      const { user } = response;
      commit('SET_PROFILE', user, { root: true });
      commit('LOGIN_SUCCESS');
      return true;
    } catch (e) {
      return false;
    }
  },
  async signup(context, payload: ISignUpRequest): Promise<ILoginRequest | Error> {
    try {
      await api.auth.signup(payload);
      const dataLogin: ILoginRequest = {
        email: payload.email,
        password: payload.password,
      };
      return dataLogin;
    } catch (e) {
      return e;
    }
  },
  async logout(context): Promise<boolean> {
    await localStorage.removeItem(PROFILE_KEY);
    return true;
  },
};
